export default "__VITE_ASSET__CjqsjSwa__"